import React, {FC, useState} from 'react'
import {Close} from 'jbc-front/components/icons'
import {fullNameFormat} from 'libs/formatter'
import {Employee} from '../query'
import styles from './ContractTargetWarnings.scss'

interface ContractTargetWarningsProps {
  employee: Employee
}

const validateContractTarget = (employee: Employee) => {
  const warnings = []

  const fullName = fullNameFormat(employee.lastName, employee.firstName)
  if (Array.from(fullName).length > 60) {
    warnings.push('氏名が60文字を超えています。依頼メールに氏名が正しく表示されない可能性があります。')
  }

  return warnings
}

export const ContractTargetWarnings: FC<ContractTargetWarningsProps> = ({employee}) => {
  const [visible, setVisible] = useState(true)
  const warnings = validateContractTarget(employee)

  if (warnings.length === 0 || !visible) {
    return null
  } else {
    return (
      <div className={styles.warningBox}>
        <div className={styles.warningBoxText}>
          以下のエラーが発生しています
          <Close className={styles.closeButton} onClick={() => setVisible(false)} />
        </div>
        {warnings.map((warning, index) => (
          <li key={index}>{warning}</li>
        ))}
      </div>
    )
  }
}
